import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { postContact } from 'actions/contact';
import { showAlert } from 'actions/common/alert';
import Contact from 'components/Contact';

const mapStateToProps = ({ contact }) => ({ ...contact });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      postContact,
      push,
      showAlert
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);



// WEBPACK FOOTER //
// ./src/containers/Contact/index.js